import React, { Component } from 'react';
import ContentSection from './ContentSection';
import { Col } from 'react-materialize';
import { defineMessages, injectIntl } from 'react-intl';

import viewerContent from '../../content/viewer-content.json';
import PilotlyCarousel from '../global/PilotlyCarousel';

const localeMessages = defineMessages({
	landing_viewer_feedback_title: {
		id: 'landing_viewer_feedback.title',
		defaultMessage: `Viewers Who Give Feedback`,
	},
});

class LandingViewerFeedback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			viewerContentArray: viewerContent.content.map((item, index) => { 
				return { ...item, active: index === 0 ? true : false };
			}),
		};
	}

	render() {
		const { viewerContentArray } = this.state;
		
		return (
			<ContentSection 
				addedSectionClass='gray-bg' 
				title={this.props.intl.formatMessage(localeMessages.landing_viewer_feedback_title)}
			>
				<div className='feedback-row row'>
					<Col className='lvf-container' s={12}>
						<div className='left-fade'></div>
						<PilotlyCarousel
							content={viewerContentArray}
						/>
						<div className='right-fade'></div>
					</Col>
				</div>
			</ContentSection>
		);
	}
}

export default injectIntl(LandingViewerFeedback);


// WEBPACK FOOTER //
// ./src/components/landing/LandingViewerFeedback.js